export default function Header() {
  return (
    <header className="bg-white border-b-2 border-gray-300 sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <h1 className="text-2xl font-bold text-gray-800" style={{ fontFamily: '"Noto Serif JP", serif' }}>
            合同会社Nature
          </h1>
          
          <nav className="hidden md:flex items-center gap-8">
            <a 
              href="#about" 
              className="text-gray-700 hover:text-green-700 font-medium transition-colors"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              会社概要
            </a>
            <a 
              href="#services" 
              className="text-gray-700 hover:text-green-700 font-medium transition-colors"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              事業内容
            </a>
            <a 
              href="#contact" 
              className="text-gray-700 hover:text-green-700 font-medium transition-colors"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              お問い合わせ
            </a>
          </nav>

          <button className="md:hidden text-gray-700">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}